var timeoutDuration = 400;
var resizeTimeout = null;
window.addEventListener('resize', function () {
	if (resizeTimeout) {
		clearTimeout(resizeTimeout);
	}
	// Debounce resize event
	resizeTimeout = setTimeout(function () {
		// On stock le scroll
		var previousScroll = currentY;

		// On le remet temporairement à 0 pour bien reconstruire toute les scenes scroll magic
		// if (!mobileCheck.isMobile) {
		// 	scrollBar.scrollTo(0, 0);
		// }

		// Reset des scenes scroll magic et autres traitements manuels
		resizeCallbacks.forEach(function (callback) {
			callback.resize();
		});

		// Restauration du scroll
		// if (!mobileCheck.isMobile) {
		// 	setTimeout(function () {
		// 		scrollBar.scrollTo(0, previousScroll);
		// 	}, 400);
		// }
	}, timeoutDuration);

	// Sans debounce
});
